import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';
import {
  PRIMARY_ROSTER,
  SECONDARY_ROSTER,
  ALTERNATE_ROSTER,
} from '../../../constants/medical_roster';

import { REQUESTING, SUCCESS } from '../../../actions/statusTypes';

import { OPComponent, Container, I18n, Utils, Navigation, NavBar, Select } from '../../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getStaffByRole, getJoinedStaff, getFullStaffRoster } from '../../staff/selector';

import { setRoster, getUsers, resetState } from '../../staff/actions';

function Column(props) {
  const { onPress } = props;
  return (
    <View style={styles.column}>
      <View style={styles.columnHeader}>
        <Text style={styles.columnHeaderText}>{props.title}</Text>
      </View>
      {props.children}
    </View>
  );
}

function LabelSection(props) {
  return (
    <View style={styles.section}>
      <Text style={styles.roleLabel}>{props.label}</Text>
    </View>
  );
}

class Main extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        rightButtons: [NavBar.buttons.save],
      },
    };
  }

  constructor(props) {
    super(props);

    this.state = {};

    this.setFocus = {};
    this.handleSelect = {};
    this._rosterItems = [];
  }

  handlerFactory = (id) => {
    let setFocus = this.setFocus[id];
    let handleSelect = this.handleSelect[id];

    if (!setFocus) {
      this._rosterItems.push(id);

      setFocus = this.setFocus[id] = () => {
        this.setState({ curSelect: id });
      };

      handleSelect = this.handleSelect[id] = (value) => {
        this.setState({ [id]: value });
      };
    }

    return { setFocus, handleSelect };
  };

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };
  componentDidMount() {
    Utils.trackScreen('Airforce', 'Medical Roster');
    Navigation.registerForButtonEvents(this);
    this.props.actions.resetState();
    this.props.actions.getUsers();
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.actions.resetState();
  }

  componentDidUpdate(prevProps) {
    if (this._saving && this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      this._saving = false;
    }

    if (prevProps.fullRoster !== this.props.fullRoster) {
      const rosterState = this.props.fullRoster.reduce((map, item) => {
        if (item.medicineType === this.props.type) {
          map[`${item.role}_${item.roster}`] = {
            label: item.user.username,
            id: item.user.userId,
          };
        }
        return map;
      }, {});

      this.setState({
        ...rosterState,
      });
    }
  }

  onSave = () => {
    this._saving = true;

    const rotations = {};
    this._rosterItems.forEach((r) => {
      const item = this.state[r];
      if (item) {
        if (!rotations[item.id]) rotations[item.id] = [];
        const rosterNum = r.split('_')[1];
        rotations[item.id].push(rosterNum);
      }
    });

    const roster = {
      medicalStaffRotation: {
        medicineType: this.props.type,
        rotations: Object.keys(rotations).map((userId) => {
          return {
            userId: parseInt(userId),
            rosters: rotations[userId],
          };
        }),
      },
    };

    // const roster = {
    //   medicalStaffRotation: {
    //     medicineType: this.props.type,
    //     rotations: [ { userId: 293, rosters: [PRIMARY_ROSTER, SECONDARY_ROSTER] } ]
    //   }
    // }
    // console.info('>>>> setRoster rotations', roster);

    // return;
    this.props.actions.setRoster(roster);
  };

  clearCurSelect = () => {
    this.setState({ curSelect: null });
  };

  renderDropDown = (id, options) => {
    const { setFocus, handleSelect } = this.handlerFactory(id);

    return (
      <View
        style={[styles.section, this.state.curSelect === id ? { zIndex: 1000 } : { zIndex: -1 }]}
      >
        <Select
          id={id}
          onBlur={this.clearCurSelect}
          onFocus={setFocus}
          onValue={handleSelect}
          required={false}
          closeOnSelect={true}
          options={options}
          label={null}
          value={this.state[id]}
          webMode={true}
        />
      </View>
    );
  };

  render() {
    const props = this.props;
    return (
      <Container
        scrollView={true}
        renderActivityOverlay={props.status === REQUESTING}
        errorMessage={props.errorMessage?.message}
        successMessage={this._saving && props.status === SUCCESS ? 'Roster Saved' : null}
      >
        <View style={styles.content}>
          <Column title="ROLE">
            <View style={styles.rolesContainer}>
              <LabelSection label="Public Health" />
              <LabelSection label="Immunizations" />
              <LabelSection label="DRHA" />
              <LabelSection label="Labs" />
              <LabelSection label="PHA" />
            </View>
          </Column>
          <Column title="PRIMARY">
            {this.renderDropDown(
              `Public Health Tech_${PRIMARY_ROSTER}`,
              this.props.publicHealthStaffOptions
            )}
            {this.renderDropDown(
              `Immunization Tech_${PRIMARY_ROSTER}`,
              this.props.immunizationsStaffOptions
            )}
            {this.renderDropDown(`DRHA Tech_${PRIMARY_ROSTER}`, this.props.drhaStaffOptions)}
            {this.renderDropDown(`Lab Tech_${PRIMARY_ROSTER}`, this.props.labsStaffOptions)}
            {this.renderDropDown(`PHA Tech_${PRIMARY_ROSTER}`, this.props.phaStaffOptions)}
          </Column>
          <Column title="SECONDARY">
            {this.renderDropDown(
              `Public Health Tech_${SECONDARY_ROSTER}`,
              this.props.publicHealthStaffOptions
            )}
            {this.renderDropDown(
              `Immunization Tech_${SECONDARY_ROSTER}`,
              this.props.immunizationsStaffOptions
            )}
            {this.renderDropDown(`DRHA Tech_${SECONDARY_ROSTER}`, this.props.drhaStaffOptions)}
            {this.renderDropDown(`Lab Tech_${SECONDARY_ROSTER}`, this.props.labsStaffOptions)}
            {this.renderDropDown(`PHA Tech_${SECONDARY_ROSTER}`, this.props.phaStaffOptions)}
          </Column>
          <Column title="ALTERNATE">
            {this.renderDropDown(
              `Public Health Tech_${ALTERNATE_ROSTER}`,
              this.props.publicHealthStaffOptions
            )}
            {this.renderDropDown(
              `Immunization Tech_${ALTERNATE_ROSTER}`,
              this.props.immunizationsStaffOptions
            )}
            {this.renderDropDown(`DRHA Tech_${ALTERNATE_ROSTER}`, this.props.drhaStaffOptions)}
            {this.renderDropDown(`Lab Tech_${ALTERNATE_ROSTER}`, this.props.labsStaffOptions)}
            {this.renderDropDown(`PHA Tech_${ALTERNATE_ROSTER}`, this.props.phaStaffOptions)}
          </Column>
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    flexDirection: 'row',
  },
  column: {
    flex: 0.25,
    borderColor: COLOR.accent,
    borderRightWidth: 1,
  },
  columnHeader: {
    backgroundColor: COLOR.altContrast,
    height: 40,
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderColor: COLOR.accent,
    borderBottomWidth: 1,
  },
  columnHeaderText: {
    ...FONT.regular,
    fontSize: 12,
    color: COLOR.text,
    marginLeft: 25,
  },
  rolesContainer: {
    backgroundColor: COLOR.altContrast,
  },
  section: {
    height: 100,
    borderColor: COLOR.accent,
    borderBottomWidth: 1,
    justifyContent: 'center',
    paddingHorizontal: 25,
  },
  roleLabel: {
    ...FONT.bold,
    color: COLOR.text,
    fontSize: 14,
  },
});

function mapStateToProps(state, ownProps) {
  const staffByRole = getStaffByRole(state);
  const allStaff = getJoinedStaff(state);

  return {
    publicHealthStaffOptions: (staffByRole['Public Health Tech'] || []).map((s) => ({
      label: s.username,
      id: s.userId,
    })),
    immunizationsStaffOptions: (staffByRole['Immunization Tech'] || []).map((s) => ({
      label: s.username,
      id: s.userId,
    })),
    drhaStaffOptions: (staffByRole['DRHA Tech'] || []).map((s) => ({
      label: s.username,
      id: s.userId,
    })),
    labsStaffOptions: (staffByRole['Lab Tech'] || []).map((s) => ({
      label: s.username,
      id: s.userId,
    })),
    phaStaffOptions: (staffByRole['PHA Tech'] || []).map((s) => ({
      label: s.username,
      id: s.userId,
    })),
    fullRoster: getFullStaffRoster(state),
    status: state.screens.staff.status,
    errorMessage: state.screens.staff.errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ setRoster, getUsers, resetState }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
